<template>
  <v-speed-dial
    v-model="fab"
    fixed
    top
    right
    direction="top"
    :open-on-hover="false"
    transition="slide-y-reverse-transition"
    style="top: calc(50vh)"
  >
    <template v-slot:activator>
      <v-btn
        v-model="fab"
        :color="enterpriseColor"
        dark
        fab
      >
        <!-- <v-icon>mdi-menu</v-icon> -->
        <v-icon v-if="fab">mdi-close</v-icon>
        <v-icon v-else>mdi-menu</v-icon>
      </v-btn>
    </template>
    <v-btn
      fab
      dark
      small
      :color="enterpriseColor"
      @click="onSave"
      :disabled="saving"
      :loading="saving"
    >
      <v-icon>mdi-content-save</v-icon>
    </v-btn>
    <v-btn
      fab
      small
      color="secundary"
      @click="onCancel"
    >
      <v-icon>mdi-undo</v-icon>
    </v-btn>
    <v-btn
      fab
      dark
      small
      color="red"
      @click="onDelete"
    >
      <v-icon>mdi-delete</v-icon>
    </v-btn>
    <v-btn
      fab
      dark
      small
      :color="enterpriseColor"
      @click="onAdd(editTMP.Type)"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      onAdd: {
        type: Function,
        required: true
      },
      onDelete: {
        type: Function,
        required: true
      },
      onCancel: {
        type: Function,
        required: true
      },
      onSave: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      fab: false,
    }),
    computed: {     
      ...mapState('app',['saving']), 
      bgColor () {
        return this.$store.state.app.BGColor
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      editTMP () {
        return this.$store.state.app.editTMP
      }
    },
  }
</script>

<style>
  /* This is for documentation purposes and will not be needed in your application */
  #create .v-speed-dial {
    position: absolute;
  }

  #create .v-btn--floating {
    position: relative;
  }
</style>